/*
 * @Author: sipeng
 * @LastEditTime: 2022-09-09 9:21:02
 * @Description:
 * @LastEditors: Please set LastEditors
 */
export default {
  underlyingRuleManagement: '基础规则管理',
  encodingRuleManagement: '编码规则管理',
  searchForTheBaseRuleName: '搜索基础规则名称',
  TheNameOfTheUnderlyingRule: '基础规则名称',
  underlyingRuleDefinitions: '基础规则定义',
  numberOfDigits: '位数',
  codeRules: '编码规则',
  encodingRules: '编码规则',
  searchForEncodingRuleNames: '搜索编码规则名称',
  theEncodingName: '编码名称',
  ruleScope: '规则范围',
  switch: '开关',
  registerAll: '全部注册',
  ruleBreakdown: '规则明细',
  associateAttributeRules: '关联属性规则',
  referenceTheUnderlyingRule: '引用基础规则',
  propertyName: '属性名称',
  customRules: '自定义规则',
  theDefaultSetting: '默认设置',
  openRegister:
    '开启全部注册：将模型中所有命名的对象全部注册，其中可匹配规则的位号按照属性规则填写相关属性。',
  closeRegister: '关闭全部注册：按照当前规则开关中为开的规则进行位号注册。',
  editTheUnderlyingRule: '编辑基础规则',
  addedBasicRules: '新增基础规则',
  ruleName: '规则名称',
  ruleDefinitions: '规则定义',
  pleaseFillInTheRegularExpression: '请填写正则表达式',
  editTheEncodingRules: '编辑编码规则',
  addedEncodingRules: '新增编码规则',
  pleaseSelect: '--请选择--',
  attributeEncodingRules: '属性编码规则',
  reg: '请输入合法的正则表达式',
  pleaseSelectTheDataYouWantToDelete: '请选择要删除的数据',
  whetherToDeleteTheUnderlyingRule: '是否删除基础规则',
  deletionSuccessful: '删除成功！',
  theStartIndexCannotBeGreaterThanTheEndIndex: '起始Index不能大于结束Index',
  theEncodingRuleCannotBeEmpty: '编码规则不能为空~',
  whetheToDeleteTheEncodingRule: '是否删除编码规则',
}
